import { Box, Grid, Skeleton, Card, CardContent } from "@mui/material";

export default function DashboardSkeleton() {
  return (
    <Box p={2}>
      {/* 🔹 Cards de resumo */}
      <Grid container spacing={2} mb={2}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item}>
            <Card>
              <CardContent>
                <Skeleton variant="text" width="60%" height={25} />
                <Skeleton variant="text" width="40%" height={40} />
                <Skeleton variant="rectangular" height={10} sx={{ mt: 1 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* 🔹 Gráficos */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="30%" height={25} />
              <Skeleton
                variant="rectangular"
                height={250}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="50%" height={25} />
              <Skeleton
                variant="circular"
                width={120}
                height={120}
                sx={{ mx: "auto", mt: 3 }}
              />
              <Skeleton variant="text" width="40%" sx={{ mx: "auto", mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* 🔹 Tabela */}
      <Card>
        <CardContent>
          <Skeleton variant="text" width="30%" height={25} />

          {[1, 2, 3, 4, 5].map((row) => (
            <Box
              key={row}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
            >
              <Skeleton variant="text" width="20%" />
              <Skeleton variant="text" width="15%" />
              <Skeleton variant="text" width="25%" />
              <Skeleton variant="text" width="10%" />
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
}